import {useElementSize} from "@mantine/hooks";

/**
 * Calculates whether the input should wrap based on text width
 * relative to available space (container minus button group).
 */
export function useInputWrapping(value: string) {
    const {ref: wrapperRef, width: wrapperWidth} = useElementSize();
    const {ref: hiddenRef, width: hiddenWidth} = useElementSize();
    const {ref: buttonGroupRef, width: buttonGroupWidth} = useElementSize();

    const inputHasLineBreak = value.includes("\n");
    const denominator = wrapperWidth - buttonGroupWidth;
    const shouldWrap =
        (denominator > 0 && hiddenWidth / denominator > 0.9) ||
        inputHasLineBreak;

    return {wrapperRef, hiddenRef, buttonGroupRef, shouldWrap};
}
